



import authenticate from './auth';
import media from './media';
import mediaDiff from './mediaDiff';
import siteData from './siteData';

export default {
    authenticate,
    media,
    mediaDiff,
    siteData,
}
